import moment from 'moment';

const SWITCH_DATE_LIMIT = 7;
export const validateSwitchDate = date => {
  if (date) {
    const now = moment(new Date());
    const future = moment(date, 'DD/MM/YYYY');
    const duration = moment.duration(future.diff(now));
    return duration.asDays() > SWITCH_DATE_LIMIT;
  }
  return 'required';
};

export const getValidationMessage = (isPristine, validationType, validationMessage) => {
  if (isPristine && (validationType === 'required' || !validationType)) {
    return validationMessage;
  }
};
